module.exports = __webpack_public_path__ + "img/product_94.6206167.webp";